import React from 'react'

const ShippingAndDelivery = () => {
  return (
    <section className="section-one">
      <div className="container">
        <div className="row">
          <div className="col-md-12">+
              <p>
                At Village Zone, we are committed to delivering your homemade products promptly and safely. 
                This Shipping & Delivery Policy outlines our processes for handling and shipping orders.
              </p>

              <p><strong>Order Processing:</strong></p>
              <p>
                Orders are typically processed within 1-3 business days after receiving confirmation. 
                Processing times may vary during high-demand periods or due to product availability.
              </p>

              <p><strong>Shipping Methods & Costs:</strong></p>
              <p>
                We offer multiple shipping options at checkout. Shipping costs are calculated based on 
                the weight of the order, destination, and selected shipping method.
              </p>

              <p><strong>Estimated Delivery Time:</strong></p>
              <ul>
                <li>Local Deliveries: 2-5 business days</li>
                <li>National Deliveries: 3-10 business days</li>
              </ul>
              <p>
                Please note that these are estimates and not guaranteed delivery timelines.
              </p>

              <p><strong>Tracking Your Order:</strong></p>
              <p>
                Once your order is shipped, you will receive an email with tracking details so you can monitor your package.
              </p>

              <p><strong>Delivery Issues:</strong></p>
              <p>
                If your package is delayed, damaged, or lost in transit, please contact our support team at 
                <a href="mailto:info@rastelx.com"> info@rastelx.com</a> so we can investigate and assist you.
              </p>

              <p><strong>Incorrect Address:</strong></p>
              <p>
                Please double-check your shipping address before submitting your order. We are not responsible for 
                delays or losses caused by incorrect or incomplete shipping information.
              </p>

              <p><strong>Contact Us:</strong></p>
              <p>
                For any further questions or concerns about your shipment, please reach out to our support team at 
                <a href="mailto:info@rastelx.com"> info@rastelx.com</a>.
              </p>

              <p>This Shipping & Delivery Policy is effective as of 2024-05-10</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ShippingAndDelivery